'use client'

import React, { useMemo } from 'react'
import { useLocale, useTranslations } from 'next-intl'

import topAirlinesData from '@/src/constants/topAirlines.json'

import { TopAirlines } from './topAirlines'

interface TopAirlinesData {
    title: string
    airlines: Array<{
        name_en: string
        name_ar?: string
        href_en: string
        href_ar?: string
    }>
}

export const TopAirlinesWrapper: React.FC = () => {
    const t = useTranslations('homePage.headings')
    const locale = useLocale()
    const data = topAirlinesData as TopAirlinesData
    const isArabic = locale === 'ar'

    const airlines = useMemo(
        () =>
            data.airlines.map(airline => ({
                ...airline,
                name: isArabic ? airline.name_ar || airline.name_en : airline.name_en,
                href: isArabic ? airline.href_ar || airline.href_en : airline.href_en
            })),
        [data.airlines, isArabic]
    )

    if (!data || !data.airlines || data.airlines.length === 0) {
        return null
    }

    return <TopAirlines title={t('topAirlines')} airlines={airlines}/>
}

export default TopAirlinesWrapper
